import { useEffect, useState } from "react";
import Notification, { handleMessageSuccess, handleMessageWarning } from "../../../../components/toast";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema, schemaDefaultValues } from "./schema";
import LibBoolean from "../../../../util/libBool";
import { id } from "date-fns/locale";
import reqInstagram from "../../../../services/reqMultiTenant/reqInstagram";
import { data } from "autoprefixer";

export const IndexHook = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	// setLoading,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		// setError,
		watch,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "onSubmit",
		//quando revalidar os campos
		resolver: zodResolver(schema),
		defaultValues: schemaDefaultValues,
	});

	const [loading, setLoading] = useState(false);
	const [dataInstagram, setDataInstagram] = useState([]);
	const [tokenInstagram, setTokenInstagram] = useState([]);
	const [postPreview, setPostPreview] = useState(null);

	const handleCloseModalRegister = () => {
		const event = new CustomEvent(`${ident}`);
		window.dispatchEvent(event);
	};

	// Observa o campo id_instagram
	const selectedIdInstagram = watch("id_instagram");
	const cod_post = watch("cod_post");
	const url_imagem = watch("url_imagem");

	//#region Fetch
	useEffect(() => {
		if (isOpenModalRegister) {
			const id =
				typeof selectedData[idTable] === "number" && !isNaN(selectedData[idTable]) ? selectedData[idTable] : 0;

			// if (id > 0) {
			fetch(id);
			// }
		} else {
			if (setSelectData) setSelectData({});

			reset();
		}
	}, [isOpenModalRegister, selectedData]);

	// Converte para string[], limpa espaços e remove duplicatas
	function toStringArray(raw) {
		if (Array.isArray(raw)) {
			return Array.from(new Set(raw.map((x) => String(x).trim()).filter(Boolean)));
		}
		if (typeof raw === "string") {
			const s = raw.trim();
			if (!s) return [];
			try {
				const j = JSON.parse(s);
				if (Array.isArray(j)) {
					return Array.from(new Set(j.map((x) => String(x).trim()).filter(Boolean)));
				}
			} catch (e) {
				// se não for JSON válido, trata como CSV / texto com colchetes
				const cleaned = s.replace(/^\[|\]$/g, "");
				return Array.from(
					new Set(
						cleaned
							.split(",")
							.map((t) => t.replace(/^"+|"+$/g, "").trim())
							.filter(Boolean),
					),
				);
			}
		}
		return [];
	}

	const fetch = async (id) => {
		try {
			setLoading(true);

			const [responsePost, responseInstagram] = await Promise.all([await fetchID(id), reqInstagram.listAll()]);

			if (responsePost.data && typeof responsePost.data === "object") {
				const data = responsePost.data;

				Object.keys(data).forEach((field) => {
					if (field === "triggers") {
						// setValue("triggers", toStringArray(data[field])); // <- agora vira string[]
						const teste = toStringArray(data[field]);
						setValue("triggers", teste);
					} else setValue(field, data[field]);
				});
			}

			setDataInstagram(responseInstagram.data);
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	//#endregion

	const getReturnUpdated = (response) => {
		if (Array.isArray(response.data)) {
			return response.data[0];
		} else if (typeof response.data === "object") {
			return response.data;
		} else {
			throw new Error("Formato do retorno inválido.");
		}
	};

	//#region onSubmit
	const handleOnSubmit = async (data) => {
		try {
			let response;
			const oldID = data[idTable];

			response = await insert(data);

			const returnUpdated = getReturnUpdated(response);

			const currentId = returnUpdated[idTable];

			await reloadData(oldID, currentId);

			handleMessageSuccess("Registro salvo com sucesso.");

			reset();
			handleCloseModalRegister();
		} catch (error) {
			if (error.field && error.field !== "ID_FORMA") {
				// errosAfterPost(error.field, error.message);
			}
			handleMessageWarning("Não foi possível salvar, " + error.message);
		}
	};

	//#endregion

	const findTokenInstragram = () => {
		const result = dataInstagram.find((item) => item.id_instagram === selectedIdInstagram);

		const token = result ? result.token_instagram : null;

		return token;
	};

	const selectedPostInstagram = (post) => {
		setValue("cod_post", post.id);
		setValue("url_imagem", post.imageUrl);
	};

	return {
		//hooks
		handleOnSubmit,
		handleCloseModalRegister,

		//useForm
		register,
		handleSubmit,
		setValue,
		control,
		setFocus,
		loading,

		//formState
		errors,
		isSubmitting,

		dataInstagram,
		selectedIdInstagram,
		url_imagem,
		selectedPostInstagram,
		findTokenInstragram,
		tokenInstagram,
		setTokenInstagram,
		postPreview,
	};
};
